import React, { useState } from 'react';
import { ButtonGroup, ToggleButton } from 'react-bootstrap';

function ControlBtn({ atualizaTipo }) {
    let ativo = localStorage.getItem("tipo");
    const [radioValue, setRadioValue] = useState(ativo);

    const radios = [
        { name: 'TRIADOS', value: '0', tipo: '0' },
        { name: 'NÃO TRIADOS', value: '1', tipo: '1' },
        { name: 'TODOS', value: '2', tipo: '2' },
    ];

    return (
        <>
            <ButtonGroup toggle>
                {radios.map((radio, idx) => (
                    <ToggleButton
                        key={idx}
                        type="radio"
                        className="Btn-filtro mt-2 mb-3"
                        name="radio"
                        value={radio.value}
                        checked={radioValue === radio.value}
                        onChange={(e) => {setRadioValue(e.currentTarget.value); atualizaTipo(radio.tipo)}}
                    >
                        {radio.name}
                    </ToggleButton>
                ))}
            </ButtonGroup>
        </>
    );





    // return (

    //     <>
    //         <ButtonGroup size="sm" className="mt-1 mb-5" data-toggle="button">
    //             <Button className="Btn-filtro" onClick={() => atualizaTipo(0)} >TRIADOS</Button>
    //             <Button className="Btn-filtro" onClick={() => atualizaTipo(1)} >NÃO TRIADOS</Button>
    //             <Button className="Btn-filtro" onClick={() => atualizaTipo(2)} >TODOS</Button>
    //         </ButtonGroup>
    //     </>
    // );
}

export default ControlBtn;